import { useTranslation } from '@web_opxp/features';
import { Link } from 'react-router-dom';
import { Themes } from '../../../services/themeManager';

interface IBackLinkProps {
  theme: Themes;
}

export default function BackLink({ theme }: IBackLinkProps) {
  const { t } = useTranslation();
  if (theme !== Themes.Edison) {
    return null;
  }
  return (
    <div className="mt-3">
      <Link
        to={{
          pathname: '/signup',
          state: {},
        }}>
        {t('common:Back')}
      </Link>
    </div>
  );
}
